import {memo} from 'react';
import {LanguagesStripData} from 'types';

type LanguagesStripProps = {
  data: LanguagesStripData
};

function LanguagesStrip({data}: LanguagesStripProps) {
  return (
    <div className="languages-root" aria-hidden={data.length === 0}>
      {
        data.map((lang) => (
          <span
            key={lang.id}
            className="language"
            title={lang.name}
            style={{
              width: lang.height,
              backgroundColor: lang.color
            }}
          />
        ))
      }
    </div>
  );
}

export default memo(LanguagesStrip);
